import React from "react";

function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-gray-800">
      <h1 className="text-3xl font-extrabold mb-6">Privacy Policy</h1>
      <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>

      <p className="mb-4">
        This Privacy Policy describes how <strong>Arabic Learning Hub</strong> ("we", "us", or "our") collects,
        uses, and shares information when you use our website and mobile application (the "Service").
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-3">1. Information We Collect</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          <strong>Account Information</strong>: If you create an account or sign in (e.g., via Clerk), we may
          collect your name, email, and profile information to provide authentication and personalize your
          experience.
        </li>
        <li>
          <strong>Usage Data</strong>: We may collect information about how you interact with lessons, games,
          pages, and features to improve the Service and ensure performance.
        </li>
        <li>
          <strong>Device and Technical Data</strong>: IP address, browser type, device identifiers, operating
          system, and app version, to support security, diagnostics, and analytics.
        </li>
        <li>
          <strong>Approximate Location</strong>: If you grant permission, we may use location to display relevant
          content (e.g., prayer times) and improve features that depend on location.
        </li>
        <li>
          <strong>Cookies and Local Storage</strong>: We use cookies, localStorage, and similar technologies
          to keep you signed in, remember preferences (e.g., install prompts), and analyze usage.
        </li>
      </ul>

      <h2 className="text-2xl font-bold mt-8 mb-3">2. How We Use Information</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Provide, operate, and maintain the Service and PWA/offline capabilities.</li>
        <li>Authenticate users, manage sessions, and secure accounts.</li>
        <li>Personalize content (e.g., lessons, progress, prompts).</li>
        <li>Monitor performance, fix errors, and improve features.</li>
        <li>Communicate important updates (e.g., service, security, or policy changes).</li>
        <li>Comply with legal obligations and enforce our terms.</li>
      </ul>

      <h2 className="text-2xl font-bold mt-8 mb-3">3. Legal Bases (EU/EEA/UK)</h2>
      <p className="mb-4">
        Where applicable, we process personal data based on: (a) contract necessity (to provide the Service),
        (b) legitimate interests (e.g., security, improvement), (c) consent (e.g., optional cookies, location),
        and (d) legal obligations.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-3">4. Sharing of Information</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          <strong>Service Providers</strong>: We may share limited data with vendors providing hosting, analytics,
          authentication, or content delivery under confidentiality obligations.
        </li>
        <li>
          <strong>Legal & Safety</strong>: We may disclose information if required by law or to protect rights,
          property, users, or the public.
        </li>
        <li>
          <strong>Business Transfers</strong>: In a merger, acquisition, or asset sale, your data may be
          transferred subject to this Policy.
        </li>
      </ul>

      <h2 className="text-2xl font-bold mt-8 mb-3">5. Children’s Privacy</h2>
      <p className="mb-4">
        Our Service is designed for families and learning. If you are a parent or guardian and believe we have
        collected personal information from a child without consent, please contact us and we will promptly
        delete such information as required by applicable law.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-3">6. Data Retention</h2>
      <p className="mb-4">
        We retain information only as long as necessary to provide the Service, comply with legal obligations,
        resolve disputes, and enforce agreements. Cookies/local storage may persist until cleared or expire.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-3">7. Your Choices</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>You can access, update, or delete your account information via the app (where available).</li>
        <li>You can control cookies and storage via your browser or device settings.</li>
        <li>You can revoke permissions such as location in your device settings.</li>
      </ul>

      <h2 className="text-2xl font-bold mt-8 mb-3">8. International Transfers</h2>
      <p className="mb-4">
        Your information may be processed in countries other than your own. Where required, we use appropriate
        safeguards such as standard contractual clauses.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-3">9. Security</h2>
      <p className="mb-4">
        We use reasonable technical and organizational measures to protect information. However, no method of
        transmission or storage is completely secure.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-3">10. Third-Party Links & Content</h2>
      <p className="mb-4">
        The Service may contain links to third-party sites or content. We are not responsible for the privacy
        practices of those third parties.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-3">11. Changes to This Policy</h2>
      <p className="mb-4">
        We may update this Policy from time to time. We will post the updated version with an updated date.
        Significant changes may be communicated within the app or by other means.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-3">12. Contact Us</h2>
      <p className="mb-2">If you have questions about this Privacy Policy or our practices, contact:</p>
      <p className="mb-1"><strong>Arabic Learning Hub</strong></p>
      <p className="mb-1">Email: support@arabiclearninghub.com</p>
      <p>Website: https://arabiclearninghub.com</p>
    </div>
  );
}

export default PrivacyPolicy;
